<template>
  <div class="app-container">
    <van-nav-bar title="企业信息" left-arrow @click-left="$router.push('/mine')" />
    <van-col :span="24" style="text-align: center;" v-if="loading">
      <van-loading size="24px">加载企业信息...</van-loading>
    </van-col>
    <van-col :span="24" v-else>
      <van-form @submit="save">
        <base-textarea label="企业全称" v-model="form.name" :showWordLimit="false" :required="true"
                       :rules="[{ required: true, message: '请输入您的企业全称' }]"
        />
        <base-input label="法人/责任人" v-model="form.corporation" :required="true"
                    :rules="[{ required: true, message: '请输入法人/责任人' }]"
        />
        <base-input label="法人身份证号" v-model="form.corporation_id_card" />
        <base-input label="联系人" v-model="form.linkman" :required="true"
                    :rules="[{ required: true, message: '请输入联系人' }]"
        />
        <base-input label="联系人手机号" v-model="form.link_phone" :required="true"
                    :rules="[{ required: true, message: '请输入联系人手机号' }]"
        />
        <base-input label="联系人邮箱" v-model="form.email" :required="true"
                    :rules="[{ required: true, message: '请输入联系人邮箱' }]"
        />
        <van-row>
          <van-col :span="6" class="form-select">
            注册区县
          </van-col>
          <van-col :span="18">
            <base-select v-model="form.reg_county_name" :options="countyList" @change="onCountyChange" />
          </van-col>
        </van-row>
        <van-row>
          <van-col :span="6" class="form-select">
            税种
          </van-col>
          <van-col :span="18">
            <base-select v-model="form.tax_name" :options="taxList" @change="onTaxChange" />
          </van-col>
        </van-row>
        <van-row>
          <van-col :span="6" class="form-select">
            企业类型
          </van-col>
          <van-col :span="18">
            <base-select v-model="form.type_name" :options="typeList" @change="onTypeChange" />
          </van-col>
        </van-row>
        <van-row>
          <van-col :span="6" class="form-select">
            所属行业
          </van-col>
          <van-col :span="18">
            <base-select v-model="form.ind_name" :options="indList" @change="onIndChange" />
          </van-col>
        </van-row>
        <base-textarea label="办公地址" v-model="form.busi_addr" :showWordLimit="false" />
        <van-col :span="22" :offset="1">
          <br>
          <base-button size="large" native-type="submit" :round="true">确定修改</base-button>
        </van-col>
      </van-form>
    </van-col>
  </div>
</template>

<script>
import { getClientDetail, modifyClient } from '@/api/client'
import { getSysDicts } from '@/api/commons'
export default {
  data() {
    return {
      loading: false,
      form: {
        client_id: this.$store.getters.currClient.client_id,
        dept_id: this.$store.getters.currClient.dept_id,
        name: '',
        corporation: '',
        corporation_id_card: '',
        linkman: '',
        link_phone: '',
        email: '',
        reg_county_name: '',
        reg_county_id: null,
        tax_name: '',
        tax_id: null,
        type_name: '',
        type_id: null,
        ind_name: '',
        ind_id: null,
        busi_addr: ''
      },
      countyList: [],
      taxList: [],
      typeList: [],
      indList: []
    }
  },
  mounted() {
    this.queryClientDetail()
    this.querySysDicts()
  },
  methods: {
    onCountyChange(val, county) {
      this.form.reg_county_id = county.id
    },
    onTaxChange(val, tax) {
      this.form.tax_id = tax.id
    },
    onTypeChange(val, type) {
      this.form.type_id = type.id
    },
    onIndChange(val, ind) {
      this.form.ind_id = ind.id
    },
    queryClientDetail() {
      this.loading = true
      getClientDetail({
        client_id: this.form.client_id,
        dept_id: this.form.dept_id
      }).then(resp => {
        Object.assign(this.form, resp.obj || {})
        if (this.form.reg_county_id) {
          this.form.reg_county_name = this.countyList.find(county => county.id === this.form.reg_county_id).name
        }
        if (this.form.tax_id) {
          this.form.tax_name = this.taxList.find(tax => tax.id === this.form.tax_id).name
        }
        if (this.form.type_id) {
          this.form.type_name = this.typeList.find(type => type.id === this.form.type_id).name
        }
        if (this.form.ind_id) {
          this.form.ind_name = this.indList.find(ind => ind.id === this.form.ind_id).name
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    querySysDicts() {
      getSysDicts({
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'asc'
      }).then(resp => {
        const rows = resp.rows || []
        this.countyList = []
        rows.forEach(row => {
          if (row.comment === '注册区县') {
            this.countyList.push(row)
          } else if (row.comment === '税种') {
            this.taxList.push(row)
          } else if (row.comment === '企业类型') {
            this.typeList.push(row)
          } else if (row.comment === '所属行业') {
            this.indList.push(row)
          }
        })
      })
    },
    save() {
      delete this.form.buy_date
      delete this.form.as_id
      delete this.form.create_time
      modifyClient(this.form).then(resp => {
        this.alert(resp.msg)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/client-info.vue